import { styled, Typography, Paper } from '@mui/material';

export const ContainerStyled = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '16px',
  border: '1px solid #B0B0B0',
  '@media (max-width:750px)': {
    display: 'none',
  },
});

export const MobileStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'scroll',
  paddingBottom: 24,
  '& h4': {
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginBottom: 24,
  },
  '@media (min-width:751px)': {
    display: 'none',
  },
}));

export const MobileTitleStyled = styled(Typography)({
  textAlign: 'center',
  fontSize: '16px',
  marginBottom: '28px',
});

export const TitlePageStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '0px 12px',
});

export const LoadingDivStyled = styled('div')({
  width: '100%',
  height: 150,
  display: 'flex',
  justifyContent: 'center',
});

export const ConstructionDetailsStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  margin: '24px 12px',
  '& p': {
    fontSize: 12,
    '&:first-child': {
      color: theme.palette.global.lightgray,
    },
  },
}));

export const TotalsContainerStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const ItemStyled = styled('div')(({ theme }) => ({
  width: '100%',
  '& .description': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 12,
    '& p:first-child': {
      color: theme.palette.secondary.main,
    },
  },
  '& .price': {
    fontSize: 12,
    paddingLeft: 16,
    color: theme.palette.global.lightgray,
  },
}));

export const SubItemStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingLeft: 8,
  width: '100%',
  '& .title': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '90vw',
    '& .totalPaid': {
      '& p': {
        color: theme.palette.primary.main,
        fontSize: 13,
      },
    },
  },
  '& .tertiaryItem': {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 16,
    marginTop: 8,
  },
}));

export const DescriptionStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  marginBottom: 8,
  '& p': {
    color: theme.palette.primary.main,
    fontSize: 13,
  },
}));

export const BudgetDetailsStyled = styled('div')(({ theme }) => ({
  margin: '8px 20px',
  color: theme.palette.global.lightgray,
  '& p': {
    fontSize: 12,
  },
}));

export const DivNoDataStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '90%',
  marginLeft: '5%',
});
